'use client'

import React from 'react'
import Image from 'next/image'
import { useModal } from '@/blocks/redesign_blocks/Modal/ModalContext'
import AnimatedSection from '@/components/AnimatedSection'
import Typography from '@/components/Typography'
import styles from './styles.module.css'

const TechnicalSupport: React.FC = () => {
	const { openConsultationModal } = useModal()

	return (
		<section className={styles.section}>
			<AnimatedSection animation="slideUp">
				<div className={styles.content}>
					<Typography variant='h1' className={styles.title}>
                    Техническое сопровождение и развитие веб-решений
					</Typography>
					<Typography variant='p1' color='description' className={styles.description}>
                    Поддерживаем стабильную работу ваших ИТ-систем 24/7. Развиваем функционал, защищаем от угроз и оперативно решаем технические задачи любой сложности.
					</Typography>
					<button 
						className={styles.button}
						onClick={openConsultationModal}
					>
						<span className={styles.buttonText}>Получить консультацию</span>
						<svg className={styles.buttonIcon} viewBox="0 0 16 16" fill="none">
							<path d="M6.33333 3V4.33333H10.7267L3 12.06L3.94 13L11.6667 5.27333V9.66667H13V3H6.33333Z" fill="white" />
						</svg>
					</button>
				</div>
			</AnimatedSection>
			<AnimatedSection animation="slideUp">
				<div className={styles.imageContainer}>
					<Image
						src="/images/services/technical-support-hero.svg"
						alt="Техническое сопровождение"
						width={1110}
						height={400}
						className={styles.desktopImage}
						unoptimized
					/>
					<Image
						src="/images/services/technical-support-hero-mobile.svg"
						alt="Техническое сопровождение"
						width={328}
						height={200}
						className={styles.mobileImage}
						unoptimized
					/>
				</div>
			</AnimatedSection>
		</section>
	)
}

TechnicalSupport.displayName = 'TechnicalSupport'

export default TechnicalSupport

